import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MuseumLeaderboardComponent } from './museum-leaderboard.component';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser'
@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    FormsModule,
    BrowserModule
  ],
  declarations: [MuseumLeaderboardComponent],
  exports: [MuseumLeaderboardComponent]
})
export class MuseumLeaderboardModule { }
